import { useMemo } from 'react';
import { UNIT_TO_MS } from '../constants';
import type { TimeFormat, Unit } from '../types';

const FORMAT_MAPPING: Record<string, Unit> = {
  D: 'days',
  H: 'hours',
  M: 'minutes',
  S: 'seconds'
};

const UNITS = Object.values(FORMAT_MAPPING);
const { days, hours, minutes } = UNIT_TO_MS;

interface FormatTimerProps {
  value: number;
  timeFormat: TimeFormat;
  editMode?: boolean;
}

export function useFormatTimer({
  value,
  timeFormat,
  editMode = false
}: FormatTimerProps): Unit[] {
  return useMemo(() => {
    if (editMode && value <= 0) {
      return UNITS;
    }

    const time = value > 0 && value < 1000 ? 1000 : value;

    if (timeFormat === 'auto') {
      const hasDays = time >= days;
      const hasHours = time >= hours;
      const hasMinutes = time >= minutes;

      const format = UNITS.filter((unit) => {
        if (unit === 'days') {
          return hasDays;
        }
        if (unit === 'hours') {
          return hasHours;
        }
        if (unit === 'minutes') {
          return hasMinutes;
        }
        if (unit === 'seconds') {
          return true;
        }

        return false;
      });

      return format;
    }

    const format: Unit[] = [];

    Object.entries(FORMAT_MAPPING).forEach(([value, unit]) => {
      if (timeFormat.includes(value)) {
        format.push(unit);
      }
    });

    return format;
  }, [value, timeFormat, editMode]);
}
